import { useLoaderData, type LoaderFunction } from "react-router";

export const newVersionCheckLoader: LoaderFunction = ({ params }) => {
  const { orderId } = params;
  const lastTwoDigits = orderId?.slice(-2);
  const isEven = Number(lastTwoDigits) % 2 === 0;

  return { newVersion: isEven };
};

export const useNewVersion = () => {
  const data = useLoaderData<{ newVersion: boolean }>();

  return Boolean(data?.newVersion); // data can be undefined.
};
